module.exports = __webpack_public_path__ + "SF-UI-Display-Regular.3f37c5de154bb3ccd811.otf";


//////////////////
// WEBPACK FOOTER
// D:/UI-PROJECTS/Helpline1097-UI/src/fonts/SF-UI-Display/SF-UI-Display-Regular.otf
// module id = ../../../../../src/fonts/SF-UI-Display/SF-UI-Display-Regular.otf
// module chunks = 2